const API_KEY = "3q7X4m0GMXKOKuUaQQyDvqU5jHLBdVe0x6nOy05";
const BASE_URL = "https://apis.bankcode-jp.com/v3";

export const searchBankName = async (inputtedBankName) => {
  const queryUrl = `apikey=${API_KEY}&filter=name==*${inputtedBankName}*`;
  const url = `${BASE_URL}/banks?${queryUrl}`;
  const res = await fetch(url);
  const data = await res.json();
  const banks = data.banks;
  return banks;
};

export const searchBranch = async (bankCode, inputtedBranchName) => {
  const queryUrl = `apikey=${API_KEY}&filter=name==*${inputtedBranchName}*`;
  const url = `${BASE_URL}/banks/${bankCode}/branches?${queryUrl}`;
  const res = await fetch(url);
  const data = await res.json();
  const branches = data.branches;
  return branches;
};
